export default __webpack_public_path__ + "static/media/image1.9bb2eb1f.jpg";